import { useMemo } from 'react'
import type { FactoryHookType } from '../type'
import maybeCreateCableThicknessFilterNode from './CableThicknessFilterNodeFactory'

const useCableThicknessFilterNode: FactoryHookType = ({ RendererComponent, options }) => {
  return useMemo(() => {
    return maybeCreateCableThicknessFilterNode({
      componentType: options.componentType,
      RendererComponent,
    })
  }, [options.componentType, RendererComponent])
}

export default useCableThicknessFilterNode
